<template>
  <app-page :title="title" wide>
    <v-layout>
      <v-flex xs12>
        <bank-details-list ref="list" :filters="query" @beforeRequest="onBeforeRequest" />
      </v-flex>
    </v-layout>
  </app-page>
</template>

<script>
import BankDetailsList from './BankDetailsList';
import { bankDetailsStatus, BankDetailsStatusEnum } from '../../constants';

export default {
  components: { BankDetailsList },

  data() {
    return {
      query: {},
    };
  },

  computed: {
    title() {
      const title = this.$t('@insurance/bankDetails/title');
      const statusVal = BankDetailsStatusEnum[this.query.status];
      const statusLocKey = bankDetailsStatus[statusVal];
      const statusLabel = this.$t(statusLocKey);
      return `${title} - ${statusLabel}`;
    },
  },

  methods: {
    async onBeforeRequest(query) {
      this.$router.replace({
        name: 'bankdetailsList',
        query: { ...this.$route.query, ...query },
      });
    },

    setQueryFromRoute(route) {
      this.query = {
        ...this.query,
        ...route.query,
        status: route.params.status,
      };
    },
  },

  mounted() {
    this.setQueryFromRoute(this.$router.currentRoute);
  },

  beforeRouteUpdate(to, from, next) {
    this.setQueryFromRoute(to);
    next();
  },
};
</script>
